const InputTrackAmount = ({ trackAmount, handleInputTrackAmount }) => {
    return (
        <input
            id='track-amount-input'
            className='track-amount-input-style'
            type='number'
            value={trackAmount}
            onChange={handleInputTrackAmount}
        />
    );
};

export default InputTrackAmount;